<template>
  <h1 class="system_content_title">角色管理</h1>
  <div class="system_content_panels">
    <div class="systemPanel" style="position: relative; padding-bottom: 40px">
      <!-- <el-form-item>
        <h3>角色管理</h3>
      </el-form-item> -->

      <el-input v-model="state.searchInput" placeholder="请输入名称" clearable @clear="queryRole" input-style="width:20%;"
        style="margin-left: 10px">
        <template #append>
          <el-button icon="Search" @click="queryRole" />
        </template>
      </el-input>

      <el-button style="margin-left: 10px" type="primary" @click="state.roleShow = true">创建角色</el-button>

      <el-button style="margin-left: 10px" type="info" @click="handleCheckRoleUsers()">角色用户</el-button>
    </div>
    <el-table :data="state.tableData" border v-loading="state.loading" @select="handleSelect" stripe
      style="min-height:70vh" table-layout="fixed" ref="tableData" @current-change="handleTableChange"
      highlight-current-row>
      <el-table-column type="selection" width="55" />
      <el-table-column prop="name" label="角色名称" width="120" />
      <el-table-column prop="typeCode" label="类型" width="100" />
      <el-table-column prop="remark" label="权限描述" />
      <el-table-column prop="menuIds" label="菜单">
        <template #default="scope">
          {{ checkIds(scope.row.menuIds) }}
        </template>
      </el-table-column>
      <el-table-column prop="regionIds" label="地区">
        <template #default="scope">
          {{ checkRegionIds(scope.row.regionIds) }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="160">
        <template #default="scope">
          {{ dateTrimmer(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column width="150" fixed="right" label="操作">
        <template #default="scope">
          <el-button type="success" size="small" @click="handleClickEdit(scope.row)">编辑</el-button>
          <el-popconfirm title="确定删除吗?" @confirm="handleClickDel(scope.row.id)">
            <template #reference>
              <el-button type="danger" size="small">删除</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="state.pageData.pageIndex" :page-sizes="[20, 50, 100, 200, 500, 1000]"
      :page-size="state.pageData.pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="state.pageData.totalRowCount" class="pageinfo">
    </el-pagination>
    <el-dialog v-model="state.roleShow" title="增加/修改角色" :before-close="handleFcancel">
      <div style="display: flex; justify-content: space-between">
        <div>
          <el-form v-model="state.form" label-position="left" label-width="100px">
            <el-form-item label="角色名称">
              <el-input v-model="state.form.name" placeholder="请输入角色名称" clearable />
            </el-form-item>
            <el-form-item label="权限描述">
              <el-input v-model="state.form.remark" placeholder="请输入权限描述" clearable />
            </el-form-item>
            <el-form-item label="类型">
              <el-input v-model="state.form.typeCode" placeholder="请输入类型" clearable />
            </el-form-item>
            <el-form-item label="流程权限">

              <el-select v-model="state.stepSelect" multiple collapse-tags placeholder="可多选" style="width: 240px">
                <el-option v-for="item in state.stepOptions" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>

          </el-form>
        </div>
        <el-scrollbar height="400px">
          <el-tree :data="state.options" show-checkbox default-expand-all node-key="id" highlight-current
            :props="state.props" @check="handleCheckChange" :default-checked-keys="state.defaultKeys" ref="menuTree"
            :current-node-key="state.currentKey" />
        </el-scrollbar>
        <el-scrollbar height="400px">
          <el-tree :data="state.regionOptions" show-checkbox default-expand-all node-key="id" highlight-current
            :props="state.regionProps" @check="handleCheckRegionChange" :default-checked-keys="state.defaultRegionKeys"
            ref="regionTree" :current-node-key="state.currentRegionKey" />
        </el-scrollbar>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleFcancel">取 消</el-button>
        <el-button type="primary" @click="handleEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue-demi";
import api from "../../http/apis";
import { ElMessageBox, ElMessage, ElTree } from "element-plus";
import { useStore } from "vuex";
import { ref, nextTick } from "vue";
export default {
  setup() {
    const store = useStore();
    const menuTree = ref();
    const regionTree = ref();
    const tableData = ref(null);
    const state = reactive({
      tableData: [],
      pageData: { pageIndex: 1, rows: 10 },
      loading: false,
      searchInput: "",
      menuStr: "",
      regionStr: "",
      form: {
        menuIds: "",
        regionIds: "",
        flowStepIds: "",
      },
      options: {},
      props: {
        multiple: true,
        label: "name",
        value: "id",
      },
      regionProps: {
        multiple: true,
        label: "name",
        value: "id",
      },
      ids: "",
      menuStrShow: false,
      roleShow: false,
      menuInfo: {},
      defaultKeys: [],
      defaultRegionKeys: [],
      seletectRoleInfo: {},
      currentKey: "",
      currentRegionKey: "",
      checkedMenuIds: [],
      checkedRegionIds: [],
      regionSelect: '',
      regionOptions: {},
      stepOptions: [],
      stepSelect: "",
    });

    const queryRole = async () => {

      state.tableData = [];
      state.loading = true;
      const { data } = await api.userApi.queryRole({
        page: state.pageData.pageIndex || 1,
        rows: state.pageData.rows || 10,
        order: "asc",
        sort: "",
        value: state.searchInput || "",
      });
      if (data.isSuccessful) {
        state.tableData = data.resultObj.data;
        state.pageData = data.resultObj.pagerInfo;
        console.info("pageData", state.pageData);
      } else {
        ElMessage({
          message: data.resultMsg || "未知错误",
          type: "error",
          grouping: true,
        });
      }

      state.loading = false;
    };
    queryRole();

    const getMenuTree = async () => {
      state.tableData = [];
      const { data } = await api.menuApi.getMenuTree();
      if (data.isSuccessful) {
        state.options = data.resultObj;
      } else {
        ElMessage({
          message: data.resultMsg || "未知错误",
          type: "error",
          grouping: true,
        });
      }
    };
    getMenuTree();

    // 重构行政区域

    // 获取行政区域
    const getFlowStepOptions = async () => {
      const { data } = await api.auditionApi.getFlowStepList()


      if (data.isSuccessful) {
        state.stepOptions = data.resultObj
      } else {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      }

    };
    getFlowStepOptions()
    const getRegionTree = async () => {
      const { data } = await api.companyApi.getGZRegionTree()


      if (data.isSuccessful) {
        state.regionOptions = data.resultObj
      } else {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      }

    };
    getRegionTree()
    const handleClickEdit = (info) => {
      state.roleShow = true;
      state.form = info;
      if (info.menuIds) {
        let arr = info.menuIds.split(",");
        state.checkedMenuIds = arr;
        arr.forEach((item) => {
          nextTick(() => {
            menuTree.value.setChecked(item, true, false);
          });
        });
      }
      if (info.regionIds) {
        let arr = info.regionIds.split(",");
        state.checkedRegionIds = arr;
        arr.forEach((item) => {
          nextTick(() => {
            regionTree.value.setChecked(item, true, false);
          });
        });
      }
      if (info.flowStepIds) {
        let arr = [];
        info.flowStepIds.split(",").forEach(item => {
          arr.push(parseInt(item))
        })
        state.stepSelect = arr;
        // arr.forEach((item) => {
        //   nextTick(() => {
        //     regionTree.value.setChecked(item, true, false);
        //   });
        // });
      }
    };

    const dateTrimmer = (str) => {
      if (str) {
        return str.split("T")[0] + " " + str.slice(11, 19);
      } else {
        return "无";
      }
    };
    const handleFcancel = () => {
      state.roleShow = false;
      state.form = {};
      state.defaultKeys = [];
      state.checkedMenuIds.forEach((item) => {
        nextTick(() => {
          menuTree.value.setChecked(item, false, false);
        });
      });
      state.checkedRegionIds.forEach((item) => {
        nextTick(() => {
          regionTree.value.setChecked(item, false, false);
        });
      });
    };
    const handleEdit = async () => {
      if (state.menuStr.length < 1) {
        menuTree.value.getCheckedKeys().forEach((item) => {
          state.menuStr += item + ",";
        });
      }
      // console.log(state.menuStr)
      const { data } = await api.userApi.addRole({
        id: state.form.id || 0,
        menuIds: state.menuStr,
        regionIds: state.regionStr,
        flowStepIds: state.stepSelect.toString(),
        name: state.form.name,
        remark: state.form.remark,
        typeCode: state.form.typeCode,
        createTime: state.form.createTime,
      });
      if (data.isSuccessful) {
        state.checkedMenuIds.forEach((item) => {
          nextTick(() => {
            menuTree.value.setChecked(item, false, false);
          });
        });
        state.checkedRegionIds.forEach((item) => {
          nextTick(() => {
            regionTree.value.setChecked(item, false, false);
          });
        });
        ElMessage({
          message: data.resultMsg,
          type: "success",
        });
        queryRole()
        state.roleShow = false;
        store.dispatch("user/setUserMenu");

      } else {
        ElMessage({
          message: data.resultMsg || "未知错误",
          type: "error",
          grouping: true,
        });
      }
    };
    const handleCheckChange = (data, checkedNodes) => {
      state.menuStr = "";
      checkedNodes.checkedKeys.forEach((item) => {
        state.menuStr += item + ",";
      });
      checkedNodes.halfCheckedKeys.forEach((item) => {
        state.menuStr += item + ",";
      });
      // console.log(state.menuStr)
    };
    const handleCheckRegionChange = (data, checkedNodes) => {
      state.regionStr = "";
      checkedNodes.checkedKeys.forEach((item) => {
        state.regionStr += item + ",";
      });
      // checkedNodes.halfCheckedKeys.forEach((item) => {
      //   state.regionStr += item + ",";
      // });
      console.log(checkedNodes.checkedKeys)
    };
    const handleSelect = (selection, row) => {
      if (selection.length > 1) {
        tableData.value.toggleRowSelection(selection[0], false);
        tableData.value.setCurrentRow(row);
      } else if (selection.length == 1) {
        // console.log(selection.length)
        tableData.value.setCurrentRow(row);
      } else if (selection == "") {
        tableData.value.toggleRowSelection(row, true);
      } else {
      }
    };
    const handleTableChange = (currentRow, oldCurrentRow) => {
      if (oldCurrentRow) {
        tableData.value.toggleRowSelection(oldCurrentRow, false);
        handleSelect("", currentRow);
      } else {
        handleSelect("", currentRow);
      }
    };
    return {
      state,
      queryRole,
      dateTrimmer,
      getMenuTree,
      handleFcancel,
      handleClickEdit,
      menuTree,
      regionTree,
      handleEdit,
      handleCheckChange,
      handleSelect,
      handleTableChange,
      tableData,
      handleCheckRegionChange
    };
  },
  methods: {
    handleSizeChange(val) {
      this.state.pageData.pageSize = val;

      this.queryRole();
    },
    handleCurrentChange(val) {
      this.state.pageData.pageIndex = val;
      this.queryRole();
    },
    async handleClickDel(id) {
      const { data } = await api.userApi.deleteRole(id);
      if (data.isSuccessful) {
        ElMessage({
          message: data.resultMsg,
          type: "success",
        });
        this.queryRole();
      } else {
        ElMessage({
          message: data.resultMsg || "未知错误",
          type: "error",
          grouping: true,
        });
      }
    },
    handleCheckRoleUsers() {
      if (!this.state.seletectRoleInfo) {
        ElMessage({
          message: "请选择角色后再进行操作！",
          type: "error",
        });
      } else {
        this.$router.push({
          path: "roleUsersTable",
          query: {
            roleId: this.state.seletectRoleInfo.id,
          },
        });
      }
    },
    checkIds(menuIds) {
      if (menuIds) {
        let arr = menuIds.split(",");
        var strArr = "";
        arr.pop();
        arr.forEach((arritem) => {
          if (this.state.options.length > 0) {
            this.state.options.forEach((infoitem) => {
              if (infoitem.children.length > 0) {
                infoitem.children.forEach((childitem) => {
                  if (childitem.id == arritem) {
                    strArr += childitem.name + ",";
                  }
                });
              } else {
                if (infoitem.id == arritem) {
                  strArr += infoitem.name + ",";
                }
              }
            });
          }
        });
      }
      return strArr;
    },
    checkRegionIds(regionIds) {
      if (regionIds) {
        let arr = regionIds.split(",");
        var strArr = "";
        arr.pop();
        arr.forEach((arritem) => {
          if (this.state.regionOptions.length > 0) {
            this.state.regionOptions.forEach((infoitem) => {
              if (infoitem.children.length > 0) {
                infoitem.children.forEach((childitem) => {
                  if (childitem.id == arritem) {
                    strArr += childitem.name + ",";
                  }
                });
              } else {
                if (infoitem.id == arritem) {
                  strArr += infoitem.name + ",";
                }
              }
            });
          }
        });
      }
      console.log(strArr)
      return strArr;
    },
  },
};
</script>

<style scoped lang='scss'>
@use "../../assets/scss/table.scss" as *;

.el-input__inner {
  width: 100%;
}
</style>
